import * as uuid from 'uuid';
import {LayerRole} from "../../qwc2/actions/layers";
import md5 from 'md5';

const RepositoryUtils = {
    ids: {},
    titles: {},

    getOverlay(repository) {
        const layer = this.convertRepoLayer({
            title: repository.title,
            active: true,
            children: repository.overlays
        }, {
            type: "hybrid",
            role: LayerRole.USERLAYER,
            expanded: true
        });
        return layer;
    },

    getBackgrounds(repository) {
        if (repository.baseLayers) {
            const layers = repository.baseLayers.map(b => {
                return this.convertRepoLayer(b, {
                    thumbnail: "img/mapthumbs/default.jpg",
                    role: LayerRole.BACKGROUND
                });
            });
            return layers;
        }
        return [];
    },

    convertRepoLayer(l, layerData) {
        if (this.ids[l.id]) {
            console.log('Duplicate layer id', l.id);
        }
        this.ids[l.id] = l.id;
        if (this.titles[l.title]) {
            console.log('Duplicate layer title', l.title);
        }
        this.titles[l.title] = l.title;

        const newSublayer = {
            ...layerData,
            id: md5(l.id + "||" + l.title),
            uuid: uuid.v4(),
            title: l.title,
            name: l.title,
            type: layerData.type || 'group',
            role: layerData.role || LayerRole.USERLAYER,
            visibility: l.active,
            zoomToExtent: false
        };
        newSublayer.drawingOrder = 50;
        if (l.zIndex) {
            newSublayer.drawingOrder = l.zIndex;
        }
        if (l.event && l.event == 'GetFeatureInfo') {
            newSublayer.queryable = true;
            if (l.featureInfoFormat) {
                newSublayer.infoFormats = [l.featureInfoFormat];
            }
            if (l.objectType) {
                if (!newSublayer.infoFormats) {
                    newSublayer.infoFormats = ['application/json'];
                }
                newSublayer.objectType = l.objectType;
            }
            if (l.source) {
                newSublayer.featureInfoUrl = l.source.url;
            }
            if (l["source-layer"]) {
                newSublayer.queryLayers = [];
                newSublayer.queryLayers.push(l["source-layer"]);
            }
        }
        if (l.layout && l.layout.indexOf('://') > -1) {
            newSublayer.layout = l.layout;
        }
        if (l.abstract) {
            newSublayer.abstract = l.abstract;
        }
        if (l.layout2) {
            newSublayer.layout = l.layout2;
        }
        if (l.previewGraphic) {
            newSublayer.thumbnail = l.previewGraphic;
        }
        //newSublayer.color = '#ff0000';
        if (l.legendGraphic) {
            newSublayer.legendUrl = l.legendGraphic;
        }
        if (l.source) {
            if (l.source.crs) {
                newSublayer.projection = l.source.crs;
            }
            if (l.source.limit) {
                newSublayer.featureLimit = l.source.limit;
            }
            if (l.source.tileSize) {
                if (newSublayer.type == "wms") {
                    newSublayer.tileSize = [l.source.tileSize, l.source.tileSize];
                } else {
                    newSublayer.tileSize = l.source.tileSize;
                }
            }
            if (l.source.provider) {
                if ("ogc-api-features" == l.source.provider.type) {
                    newSublayer.type = l.source.provider.format;
                } else {
                    newSublayer.type = l.source.provider.type;
                }
                if (l.source.provider.version) {
                    newSublayer.version = l.source.provider.version;
                }
            }
            if (l.source.url) {
                if (l.source.filter && l.source.filter !== '') {
                    newSublayer.dynamicUrl = l.source.url;
                    newSublayer.dynamicFilter = l.source.filter;
                    this.applyAllFilters(newSublayer, 0, null);
                } else {
                    newSublayer.url = l.source.url;
                }
                if (l.source.auth) {
                    //const auth = l.source.auth.user + ":" + l.source.auth.password + "@";
                    //newSublayer.url = newSublayer.url.replace("://", "://" + auth);
                }
            }
            if (l.source.attribution) {
                newSublayer.attribution = {
                    Title: l.source.attribution
                };
            }
            if (l.source.auth) {
                newSublayer.auth = l.source.auth;
            }
            if (l.source.bounds && l.source.bounds != "") {
                if (newSublayer.tileSize) {
                    newSublayer.tiled = true;
                }
                newSublayer.bbox = {
                    bounds: l.source.bounds.split(","),
                    crs: l.source.crs
                };
            }
        }
        if (newSublayer.type == "wfs") {
            //newSublayer.formats = ['text/xml'];
            newSublayer.formats = ['gml3'];
            if (l["source-layer"]) {
                let wfsName = l["source-layer"];
                if (l.source && l.source.provider && l.source.provider.featurePrefix) {
                    wfsName = l.source.provider.featurePrefix + ':' + wfsName;
                }
                newSublayer.name = wfsName;
            }
        }
        if (newSublayer.type == "wms") {
            if (l["source-layer"]) {
                let layerStyle = '';
                if (l.layout && l.layout.indexOf('://') === -1) {
                    layerStyle = l.layout;
                }
                newSublayer.serverType = 'geoserver';
                newSublayer.params = {
                    LAYERS: l["source-layer"],
                    STYLES: layerStyle
                };
            }
            if (l.source && l.source.auth) {
                newSublayer.wmsBasicAuth = {
                    username: l.source.auth.user,
                    password: l.source.auth.password
                };
            }
        }

        if (l.tags) {
            newSublayer.tags = l.tags;
        }
        if (l.addComponents) {
            newSublayer.addComponents = l.addComponents;
        }
        if (l.minScale) {
            newSublayer.minScale = l.minScale - 1;
        }
        if (l.maxScale) {
            newSublayer.maxScale = l.maxScale + 1;
        }
        if (l.children && l.children.length > 0) {
            newSublayer.sublayers = l.children.map(l => this.convertRepoLayer(l, {}));
        }
        //console.log('New Layer', newSublayer.type, newSublayer);
        if (newSublayer.type == 'none') {
            //console.log('None', l);
        }
        return newSublayer;
    },

    flattenLayers(layers) {
        let result = [];
        layers.forEach(l => {
            result = result.concat(RepositoryUtils.flattenLayer(l));
        });

        return result;
    },

    flattenLayer(layer) {
        let result = [];
        result.push(layer);
        if (layer.sublayers) {
            for (const sublayer of layer.sublayers) {
                result = result.concat(RepositoryUtils.flattenLayer(sublayer));
            }
        }
        return result;
    },

    getQueryLayers(layers) {
        let maplayers = [];
        for (const sublayer of layers) {
            maplayers = maplayers.concat(RepositoryUtils.flattenLayer(sublayer));
        }
        const queryableLayers = maplayers.filter((l) => {
            // All non-background WMS layers with a non-empty queryLayers list
            return l.visibility && l.type === 'wms' && l.role !== LayerRole.BACKGROUND && l.queryable;
        });
        return queryableLayers;
    },

    /**
     * Returns a copy of the layer (including its sublayers) with the level and layer filters applied.
     * The passed layer is not modified, so this is safe to use within a reducer.
     */
    applyFiltersToLayer(layer, level, layerFilters) {
        const result = {...layer};
        if (layer.sublayers) {
            result.sublayers = layer.sublayers.map(sublayer => RepositoryUtils.applyFiltersToLayer(sublayer, level, layerFilters));
        }
        if (result.dynamicFilter) {
            result.baseParams = {...(layer.baseParams || {})};
            RepositoryUtils.applyAllFilters(result, level, layerFilters);
        }
        return result;
    },

    applyAllFilters(layer, level, layerFilters) {
        layer.filterLevel = level;
        layer.layerFilters = layerFilters;

        const base = layer.dynamicUrl;
        layer.url = base;

        let filterPart = layer.dynamicFilter;

        // set level filter
        const separator = (base.indexOf('?') > 0) ? '&' : '?';
        if (filterPart.indexOf('{level}') > -1) {
            filterPart = filterPart.replaceAll('{level}', level);
        }

        // apply layer filters
        filterPart = filterPart.replaceAll(' and ', ' AND ');
        const conditions = filterPart.split(' AND ');
        const keep = [];
        //console.log('Filter before', filterPart, layerFilters);
        const regex = new RegExp('{[a-z]+}');
        for (let i = 0; i < conditions.length; i++) {
            let condition = conditions[i];
            if (regex.test(condition)) {
                if (layerFilters === null) {
                    // do not keep it. it is not set yet
                } else {
                    let useFilter = false;

                    for (let j = 0; j < layerFilters.length; j++) {
                        const layerFilter = layerFilters[j];
                        const vn = layerFilter.variable;
                        const vnMin = vn + "min";
                        const vnMax = vn + "max";
                        if (condition.indexOf(vn) > -1 || condition.indexOf(vnMin) > -1 || condition.indexOf(vnMax) > -1) {
                            const type = typeof (layerFilter.currentFilterValues);
                            switch (type) {
                                case 'object':
                                    if (Array.isArray(layerFilter.currentFilterValues)) {
                                        if (layerFilter.currentFilterValues.length > 0) {
                                            const exprs = [];
                                            layerFilter.currentFilterValues.forEach(val => {
                                                exprs.push("'" + val + "'");
                                            });
                                            condition = condition.replaceAll('{' + vn + '}', exprs.join(','));
                                            useFilter = true;
                                        }
                                    } else {
                                        useFilter = true;
                                        condition = condition.replaceAll('{' + vnMin + '}', layerFilter.currentFilterValues.min);
                                        condition = condition.replaceAll('{' + vnMax + '}', layerFilter.currentFilterValues.max);
                                    }
                                    break;
                                case 'boolean':
                                    useFilter = true;
                                    condition = condition.replaceAll('{' + vn + '}', JSON.stringify(layerFilter.currentFilterValues));
                                    break;

                            }

                            break;
                        }
                    }

                    if (useFilter) {
                        keep.push(condition);
                    }
                }
            } else {
                keep.push(condition);
            }
        }
        filterPart = keep.join(' AND ');
        //console.log('Filter after', filterPart);

        // build new url
        if (layer.type === "wms") {
            if (typeof (layer.baseParams) === 'undefined') {
                layer.baseParams = {};
            }
            layer.baseParams['CQL_FILTER'] = filterPart;
        } else {
            layer.url = base + separator + 'filter=' + encodeURIComponent(filterPart);
        }
    }
};

export default RepositoryUtils;
